import { memo } from "react";

const trimToFit = (string, len) => {
  if (string.length <= len) {
    return string;
  } else {
    string = string.substring(0, len);
    return string.substr(0, string.lastIndexOf(" ")) + " ...";
  }
};

const formatMobile = number =>
  number.length === 12
    ? `+${number.substr(0, 2)}-${number.substr(2, 12)}`
    : number;

const withMemo = (Component, checkedProps) => {
  function areEqual(prevProps, nextProps) {
    let isEqual = true;
    for (let i = 0; i < checkedProps.length; i++) {
      const checkedProp = checkedProps[i];
      if (
        JSON.stringify(prevProps[checkedProp]) !==
        JSON.stringify(nextProps[checkedProp])
      ) {
        isEqual = false;
        break;
      }
    }
    return isEqual;
  }

  return memo(Component, areEqual);
};

export { trimToFit, formatMobile, withMemo };
